import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const Footer = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <footer style={{
      background: isDarkMode ? '#333' : '#f8f9fa',
      color: isDarkMode ? '#fff' : '#333',
      padding: '1.5rem 0',
      marginTop: 'auto',
      borderTop: isDarkMode ? 'none' : '1px solid #e9ecef',
      position: 'relative'
    }}>
      <div className="container">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: 'clamp(1.5rem, 6vw, 4rem)',
          marginBottom: '1.5rem',
          maxWidth: '1200px',
          margin: '0 auto 1.5rem auto',
          flexWrap: 'wrap'
        }}>
          {/* Left Section - AI-MCP-Bio */}
          <div style={{ maxWidth: '300px' }}>
            <h3 style={{
              color: isDarkMode ? '#66B3FF' : '#0099FF',
              fontWeight: 'bold',
              marginBottom: '0.75rem',
              fontSize: '1.2rem'
            }}>
              AI-MCP-Bio
            </h3>
            <p style={{
              color: isDarkMode ? '#ccc' : '#666',
              fontSize: '0.9rem',
              lineHeight: '1.4',
              marginBottom: '0.75rem'
            }}>
              Connect your AI to specialized bioinformatics tools through a standardized interface.
            </p>
            <a 
              href="https://github.com/icrespocasajus/AI-MCP-Bio" 
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: isDarkMode ? '#ccc' : '#666',
                textDecoration: 'none',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
              </svg>
              View on GitHub
            </a>
          </div>

          {/* Right Section - PLATFORM, ACCOUNT, and ARTWORK */}
          <div style={{
            display: 'flex',
            gap: 'clamp(1rem, 4vw, 2rem)',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            {/* PLATFORM Section */}
            <div>
              <h3 style={{
                color: isDarkMode ? '#fff' : '#333',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                fontSize: '1rem',
                textTransform: 'uppercase'
              }}>
                PLATFORM
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <Link 
                  to="/" 
                  style={{ 
                    color: '#9D4EDD', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem', 
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = '#7B2CBF';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(111, 66, 193, 0.1)' : 'rgba(111, 66, 193, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = '#9D4EDD';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Home
                </Link>
                <Link 
                  to="/mcp-servers" 
                  style={{ 
                    color: '#0099FF', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem', 
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = '#0077CC';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(0, 123, 255, 0.1)' : 'rgba(0, 123, 255, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = '#0099FF';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  MCP Servers
                </Link>
                <Link 
                  to="/workflows" 
                  style={{ 
                    color: '#00CC66', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem', 
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = '#00AA55';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(40, 167, 69, 0.1)' : 'rgba(40, 167, 69, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = '#00CC66';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Workflows
                </Link>
              </div>
            </div>

            {/* ACCOUNT Section */}
            <div>
              <h3 style={{
                color: isDarkMode ? '#fff' : '#333',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                fontSize: '1rem',
                textTransform: 'uppercase'
              }}>
                ACCOUNT
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <Link 
                  to="/login" 
                  style={{ 
                    color: isDarkMode ? '#e0e0e0' : '#333', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = isDarkMode ? '#fff' : '#000';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = isDarkMode ? '#e0e0e0' : '#333';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Login
                </Link>
                <Link 
                  to="/register" 
                  style={{ 
                    color: isDarkMode ? '#e0e0e0' : '#333', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = isDarkMode ? '#fff' : '#000';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = isDarkMode ? '#e0e0e0' : '#333';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Sign Up
                </Link>
                <Link 
                  to="/cart" 
                  style={{ 
                    color: isDarkMode ? '#e0e0e0' : '#333', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = isDarkMode ? '#fff' : '#000';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = isDarkMode ? '#e0e0e0' : '#333';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Cart
                </Link>
              </div>
            </div>

            {/* ARTWORK Section */}
            <div>
              <h3 style={{
                color: isDarkMode ? '#fff' : '#333',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                fontSize: '1rem',
                textTransform: 'uppercase'
              }}>
                ARTWORK
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <Link 
                  to="/art" 
                  style={{ 
                    color: isDarkMode ? '#e0e0e0' : '#333', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = isDarkMode ? '#fff' : '#000';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = isDarkMode ? '#e0e0e0' : '#333';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  AI-MCP-Bio
                </Link>
              </div>
            </div>

            {/* CONTACT Section */}
            <div>
              <h3 style={{
                color: isDarkMode ? '#fff' : '#333',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                fontSize: '1rem',
                textTransform: 'uppercase'
              }}>
                CONTACT
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <Link 
                  to="/team" 
                  style={{ 
                    color: isDarkMode ? '#e0e0e0' : '#333', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    transition: 'color 0.3s ease',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = isDarkMode ? '#fff' : '#000';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = isDarkMode ? '#e0e0e0' : '#333';
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  Our Team
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Separator Line */}
        <div style={{
          borderTop: isDarkMode ? '1px solid #555' : '1px solid #e9ecef',
          marginBottom: '0.75rem'
        }}></div>

        {/* Copyright Section */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: isDarkMode ? '#ccc' : '#666', fontSize: '0.9rem', margin: 0 }}>
            © 2025 AI-MCP-Bio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
